const state = () => ({
  isToggle : false ,
	isToggleLock : false,
});

const getters = {
	getIsToggle: state => state.isToggle,
	getIsToggleLock : state => state.isToggleLock
};

const actions = {

	// 햄버거 토글메뉴 자동 반대로
	toggle({ commit , state  }) {  
    commit('SET_IS_TOGGLE' , !state.isToggle);
	},
	// 햄버거 토글메뉴 내가 지정한값으로
	setToggle({ commit }, isToggle) {  
    commit('SET_IS_TOGGLE' , isToggle);
	},

	setToggleLock({ commit }, isToggleLock) {  
    commit('SET_IS_TOGGLE_LOCK' , isToggleLock);
	},

	
};

const mutations = {
	SET_IS_TOGGLE(state, payload) {
		state.isToggle = payload;
	},

	SET_IS_TOGGLE_LOCK(state, payload) {
		state.isToggleLock = payload;
	},

};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
